import React, {useState} from 'react';

import LiveRegion from 'lib/LiveRegion';

import type {CalculatorType} from './CalculatorTitleBar.react';

/** Accessible names of the calculators, by type. */
export const CALCULATOR_NAMES: Readonly<Record<string, string | undefined>> = {
  basic: 'Basic calculator',
  graphing: 'Graphing calculator',
  scientific: 'Scientific calculator'
} satisfies Record<CalculatorType, string>;

/**
 * Politely speaks `name` each time it changes after mounting. Hosts mount it only while a
 * calculator is showing, so a first load or an open stays silent.
 */
export function CalculatorTypeAnnouncer({name}: {name: string | undefined}) {
  const [shownName, setShownName] = useState(name);
  const [announcement, setAnnouncement] = useState('');
  if (name !== shownName) {
    setShownName(name);
    setAnnouncement(name ?? '');
  }

  return (
    <LiveRegion assertive={false} className='sr-only'>
      {announcement}
    </LiveRegion>
  );
}
